import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Botón de descarga de PDF de una ficha (ticket o incidencia) en SERVICE Studio.
export default function FieldRecordPDF({ item, kind }) {
  const [busy, setBusy] = useState(false);
  const path = kind === "incident" ? `/field/incidents/${item.id}/pdf` : `/field/tickets/${item.id}/pdf`;
  const fname = kind === "incident" ? `Incidencia-${item.id?.slice(0, 8)}.pdf` : `Ticket-${item.folio || item.id}.pdf`;

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = fname; document.body.appendChild(a); a.click();
      a.remove(); URL.revokeObjectURL(url);
    } catch { toast.error("No se pudo generar el PDF"); } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4">
      <button onClick={download} disabled={busy} className="btn btn-outline text-sm" data-testid="field-record-pdf">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />} Descargar PDF
      </button>
    </div>
  );
}
